module.exports = __webpack_public_path__ + "static/media/plus-btn.33572e25.svg";